<template>
  <div id="home">
    <!-- <div class="home-title-box">
      <div class="home-title-logo">
        <img src="../assets/img/BEQ.png" alt="" />
      </div>
    </div> -->
    <div class="banner-box" v-if="$router.currentRoute.value.href !== '/2021/show'">
      
      <!-- <div class="box"> -->
      <!-- <el-button class="uploadLink" @click="uploadFile">上传作品</el-button> -->
      <!-- </div> -->
      <img @click='rewardClick' src="@/assets/img/reward.png" alt="">
    </div>
    <div class="nav-menu-box" v-if="$router.currentRoute.value.href !== '/2021/show'">
      <ul class="nav-menu-List">
        <router-link
          :to="item.path"
          v-text="item.meta.title"
          class="menu-item"
          :class="{ 'router-link-active': item.path == menuPath }"
          v-for="(item, index) in navMenu"
          :key="index"
        ></router-link>
      </ul>
    </div>
    <div class="container-box">
      <div class="conatiner">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { reactive, watch, ref } from "vue";
import menuList from "../router/menuList";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "Home",
  setup() {
    const navMenu = reactive(menuList);
    const route = useRoute();
    const router = useRouter();
    const menuPath = ref(route.meta.menuPath);
    console.log(menuPath.value);
    // watch 监听
    watch(
      () => route.meta,
      (val, oldval) => {
        console.log(oldval, val);
        menuPath.value = val.menuPath;
      }
    );

    function uploadFile() {
      router.push({ path: "/upLoadFile" });
      document.documentElement.scrollTop = 820;
    }
    return {
      navMenu,
      menuPath,
      uploadFile,
    };
  },
  methods: {
  rewardClick() {
    console.log(this.$router.replace('/designReward'))
  }
  }
  ,
  mounted() {
    console.log()
  }
};

</script>

<style lang="less">
#home {
  .uploadLink {
    position: absolute;
    left: 18.5%;
    bottom: 23%;
    width: 13vw;
    height: 4vw;
    min-width: 225px;
    min-height: 65px;
    font-weight: bold;
    opacity: 0;
  }
  // .box {
  //   position: relative;
  //   width: 1220px;
  //   margin: auto;
  //   height: 100%;

  // }
  min-width: 1200px;
  // overflow: auto;
  min-height: 800px;
  // background-color: #f7f7f7;
  .home-title-box {
    height: 60px;
    background-color: #000;
    .home-title-logo {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      img {
        height: 25px;
      }
    }
  }
  .banner-box {
    height: 42.7vw;
    background: url("../assets/img/主视觉 .jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    >img {
      height: 4.744vw;
      position: absolute;
      left: 19%;
      bottom: 21%;
    }
    // min-height: 820px;
  }
  .nav-menu-box {
    height: 80px;
    background-color: #292929;
    .nav-menu-List {
      max-width: 1600px;
      min-width: 1200px;
      margin: 0 auto;
      height: 80px;
      line-height: 80px;
      display: flex;
      align-items: center;
      .menu-item {
        height: 80px;
        max-width: 320px;
        letter-spacing: 3px;
        flex: 1;
        text-align: center;
        cursor: pointer;
        text-decoration: none;
        font-size: 30px;
        font-weight: bold;
        color: #fff;
      }
      .router-link-active {
        background-color: #94282e;
      }
      .menu-item:hover {
        background-color: #94282e;
      }
    }
  }
  // .container-box {
  //   padding-top: 70px;
  // }
  .conatiner {
    // min-height:400px;
    // width: 1200px;
    box-sizing: border-box;

    // background-image: ;
    // margin: 0 auto;
  }
}
</style>
